// extracted by css-extract-rspack-plugin
export default {"cls1":"utils-cls1_BJq","cls2":"utils-cls2_S2G utils-cls1_BJq"};